<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <div class="column is-8">
          <h4 class="is-size-4-desktop">Recuentos</h4>
          <h4 class="is-size-6-desktop">
            Sucursal: {{ bodega.sucursal.nombre }} / {{ bodega.nombre }}
          </h4>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="recuentos"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            :loading="isLoading"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
            :row-class="(row, index) => colorFila(row, index)"
          >
            <b-table-column
              v-slot="props"
              field="id"
              label="Nº SAP"
              width="7%"
              class="has-text-centered"
            >
              {{ props.row.documentNumber }}
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="id"
              label="F. Creación"
              width="9%"
              class="has-text-centered"
            >
              {{ format(parseISO(props.row.fechaCreacion), 'dd/MM/yy HH:mm') }}
            </b-table-column>
            <b-table-column v-slot="props" field="motivo" label="Motivo">
              <span>
                {{ props.row.motivo }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="comentario"
              label="Comentario"
            >
              <span>
                {{ props.row.comentario }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="estado"
              label="Estado"
              width="12%"
              style="vertical-align: middle"
            >
              <RecuentoStatus
                v-if="props.row.estado === 'ActualizandoSap'"
                :recuento="props.row.documentEntry"
              />
              <span v-else span>
                {{ props.row.estado }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="tipo"
              label="Tipo Recuento"
              width="8%"
            >
              <span>
                {{ props.row.tipo }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="bodega"
              label="Bodega"
              width="5%"
            >
              <span>
                {{ props.row.bodega.codigo }}
              </span>
            </b-table-column>
            <b-table-column v-slot="props" label="Acciones" width="8%" centered>
              <router-link
                tag="button"
                class="button is-small is-info mr-1"
                title="Ver detalle"
                :to="`/inventario/recuento/${props.row.id}`"
              >
                <b-icon icon="eye" />
              </router-link>

              <b-button
                v-if="props.row.estado === 'Completado'"
                class="is-small is-primary"
                title="Finalizar recuento"
                @click="confirmarCerrarRecuento(props.row.id)"
              >
                <b-icon icon="check" />
              </b-button>
              <b-button
                v-if="props.row.estado === 'Abierto'"
                class="is-small is-info"
                title="Cambiar Tipo"
                @click="cambiarTipoRecuento(props.row.id)"
              >
                <b-icon icon="sync-alt" />
              </b-button>
              <b-button
                v-if="
                  bodega.roles.some((r) => r.id === 5) &&
                  props.row.estado !== 'ActualizandoSap'
                "
                class="is-small is-danger ml-1"
                title="Cancelar recuento"
                @click="confirmarCancelarRecuento(props.row.id)"
              >
                {{ /* Se agrega botón de cancelar recuento para administrador de inventario */ }}
                <b-icon icon="times" />
              </b-button>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button
            type="is-info"
            :disabled="isLoading"
            icon-left="sync-alt"
            @click="getRecuentos()"
          >
            Actualizar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapGetters } from 'vuex'

import { inventarioService } from '@/services'
import RecuentoStatus from '@/components/inventario/RecuentoStatus.vue'

export default {
  name: 'Recuentos',
  components: {
    RecuentoStatus
  },
  data() {
    return {
      recuentos: [],
      paginaActual: 1,
      tamanoPagina: 10,
      isLoading: false,
      newIds: [],
      format,
      parseISO
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega'])
  },
  created() {
    this.newIds = this.$route.query.ids || []
    if (this.newIds.length > 0) this.$router.replace({})
    this.getRecuentos()
  },
  methods: {
    colorFila(row) {
      return this.newIds.includes(row.id) && 'new-recuento'
    },
    async getRecuentos() {
      const self = this
      self.isLoading = true
      await inventarioService
        .getRecuentos(this.bodega.id)
        .then((response) => (self.recuentos = response.data))
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    },
    confirmarCerrarRecuento(id) {
      this.$buefy.dialog.confirm({
        title: 'Finalizar Recuento',
        message: `Al finalizar este recuento, no se podrá volver a modificar y se actualizar&aacute;n los sistemas SAP y PBE. ¿Desea continuar?`,
        confirmText: 'Finalizar Recuento',
        cancelText: 'Volver',
        type: 'is-primary',
        hasIcon: true,
        onConfirm: () => this.closeRecuento(id)
      })
    },
    confirmarCancelarRecuento(id) {
      this.$buefy.dialog.confirm({
        title: 'Cancelar Recuento',
        message: `Al cancelar este recuento, no se podrá volver a modificar. ¿Desea continuar?`,
        confirmText: 'Cancelar Recuento',
        cancelText: 'Volver',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.cancelarRecuento(id)
      })
    },
    async closeRecuento(recuentoId) {
      const self = this
      self.isLoading = true
      await inventarioService
        .finalizarRecuento(recuentoId)
        .then((rs) => {
          this.notificarAccionCompletada(rs.data)
          this.getRecuentos()
        })
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    },
    async cancelarRecuento(recuentoId) {
      const self = this
      self.isLoading = true
      await inventarioService
        .cancelarRecuento(recuentoId)
        .then((rs) => {
          this.notificarAccionCompletada(rs.data)
          this.getRecuentos()
        })
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    },
    async cambiarTipoRecuento(recuentoId) {
      const self = this
      self.isLoading = true
      await inventarioService
        .cambiarTipoRecuento(recuentoId)
        .then((rs) => {
          this.recuentos = this.recuentos.map((item) => {
            if (item.id === rs.data.id) {
              item.tipo = rs.data.tipo
            }
            return item
          })
          this.notificarAccionCompletada(
            'Se cambió el tipo de recuento correctamente'
          )
        })
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    }
  }
}
</script>

<style lang="scss">
$baseColor: #fff;
$newColor: #50c878;

tr.new-recuento {
  animation: 3s ease 1 newrow;
}

@keyframes newrow {
  0% {
    background: $newColor;
  }

  100% {
    background: $baseColor;
  }
}
</style>
